import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {GlobalAppService} from '../../../../core/commons/global-app.service';
import {FormViewService} from '../../../services/form-view.service';
import {FormViewData} from 'app/form-views/domain/form-view-data';
import {Paragraph, TextElement, ViewModelText} from "../../view-field/view-field.component";

@Component({
    selector: 'app-form-view-data-detail',
    templateUrl: './form-view-data-detail.component.html',
    styleUrls: ['./form-view-data-detail.component.scss'],
    providers: [FormViewService]
})

export class FormViewDataDetailComponent implements OnInit {

    viewData: FormViewData = null;

    document: ViewModelText = new ViewModelText();

    constructor(private route: ActivatedRoute,
                private router: Router,
                private appService: GlobalAppService,
                private viewService: FormViewService,
    ) {
    }

    ngOnInit() {
        this.route.params
            .map(params => params['id'])
            .switchMap(id => this.viewService.getViewData(id, true))
            .subscribe(view => {
                this.viewData = view;
                this.document = view.generateViewModelText();
            });
    }

    download(){
        this.viewService.download(this.viewData.id).subscribe(res => {
            const fileURL = URL.createObjectURL(res);
            const downloadLink = document.createElement('a');
            downloadLink.href = fileURL;
            downloadLink.download = this.viewData.view.name + '_' +
                new Date(this.viewData.filledTime).toLocaleDateString() + '_' +
                this.viewData.id + '.pdf';
            downloadLink.click();
        });
    }


}



// WEBPACK FOOTER //
// ./src/app/form-views/components/data/form-view-data-detail/form-view-data-detail.component.ts